
import { useTransition, memo, useEffect, useState, useCallback, ReactNode, ReactElement, useContext } from "react";
import { FixedSizeList, ListChildComponentProps } from 'react-window';
import {
    Unstable_Grid2 as Grid, Checkbox, Box, Button, Card, CardContent, CardHeader,
    Autocomplete, MenuItem, Paper, Select, List, ListItem, ListItemIcon, TextField, Typography, alpha, styled, IconButton,
    ListItemText, Skeleton, Chip, ListItemButton, ButtonGroup, colors, FormControl, FormHelperText, SelectChangeEvent
} from "@mui/material";
import SplitButton from '../splitbutton';
import { SplitMenuItem, DataOutput, DataField, DropdownModel, DataRow, NLCInfo, AcceptanceDataOutput, SelectableItem } from "../../data/interfaces/sharedmodels";
import dayjs from "dayjs";
import {
    OpenInFullSharp as OpenInFullSharpIcon, CloseFullscreenSharp as CloseFullscreenSharpIcon,
    KeyboardArrowLeft, KeyboardArrowRight, KeyboardArrowLeftRounded, ArrowCircleLeft, Delete
} from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from "../../stores/hooks";
import { updateDatatableExpanded as magneticupdateDatatableExpanded, updateselectedNlcs, updateVersion as updateMagneticVersion } from "../../stores/magneticslice";
import { updateDatatableExpanded as itsoupdateDatatableExpanded, updateVersion as updateItsoVersion  } from "../../stores/itsoslice";
import magneticService from "../../data/api/magnetic.service";
import { showerrormessage, showsuccessmessage,showwarningmessage } from "../../stores/notificationslice";
import ConfirmDialog from "../confirmdialog";
import DataTableHeader from "../childcomponents/datatableheader";
import { formatValueAsReadOnly,formatValue,formatValueForApi } from "../commonfunctions";
import { IsEditedContext } from "../../../App";






const EditableAcceptanceList = ({ data,parent,callback }: { data: AcceptanceDataOutput,parent:string,callback:any }) => {
    const [groups, setGroups] = useState<DropdownModel[]>([]);
    const [selectedGroup, setSelectedGroup] = useState<DropdownModel | null>(null);
    const [currentData, setCurrentData] = useState<AcceptanceDataOutput>(data);
    const [searchText, setSearchText] = useState<string>('');
    const [groupHeader, setGroupHeader] = useState<string>('Select');
    const [availableItems, setAvailableItems] = useState<DropdownModel[]>([]);
    const [selectedAcceptedHeader, setSelectedAcceptedHeader] = useState<string>('Accepted');
    const [availableItemsHeader, setAvailableItemsHeader] = useState<string>('Accepted');
    const [width, setWidth] = useState('100%')
    const [showAdd, setShowAdd] = useState(false);
    const [tempTypeText, setTempTypeText] = useState<string | null>(null);
    const [tempIdCounter,setTempIdCounter]=useState(-100);
    const { setIsEdited } = useContext(IsEditedContext) ;
    const selectedTable = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedDataTable; }
        else { return state.itsoReducer.selectedDataTable; }
    });
    const selectedNlcs = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedNlcs; }
        else { return state.itsoReducer.selectedNlcs; }
    });
    const selectedVersion = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedVersion; }
        else { return state.itsoReducer.selectedVersion; }
    });
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const [dialogTitle, setDialogTitle] = useState<string>('');
    const [dialogMessage, setDialogMessage] = useState<string>('');

    const dispatch=useAppDispatch();

    const CustomListItem = (props: ListChildComponentProps) => {
        const { index, style } = props;
        const [item, setItem] = useState<DropdownModel>(availableItems[index]);
        return (
            item ? <ListItem
                style={style}
                key={item.Id}
                role="listitem"
                disablePadding
                secondaryAction={
                   currentData.IsEditable? <IconButton edge="end" aria-label="comments" onClick={(event) => onClickAddtoLeft(event, item)}>
                        <ArrowCircleLeft sx={{ color: "primary.main" }} />
                    </IconButton>:null
                }
            >
                <ListItemText primary={item.Id + " - " + item.Description} />
            </ListItem>
                : null
        )
    }
    const MeomisedListItem = memo(CustomListItem, (prevProps, nextProps) => {
        return availableItems[nextProps.index].Id === availableItems[prevProps.index].Id;
    })
    useEffect(() => {
        if (data && data.TypeLookups && data.Fields) {
            let tempGroups = data.TypeLookups.length > 0 ? data.TypeLookups.filter(a => a.FieldName == "Type")[0].LookUpValues : [];
            setGroupHeader('Select ' + ((data.Fields.length && data.Fields.filter(a => a.Name == "Type")[0].Description) ?? ''));
            setSelectedAcceptedHeader(data.Fields.length ? (data.Fields.filter(a => a.Name == "Description")[0].Description + 's in the list' +
                (data.Fields.findIndex(a => a.Description === "Capture") > -1 ? "(tick for capture)" :
                    data.Fields.findIndex(a => a.Description === "Accepted") ? "(tick for accepted)" : "") ) : '');
            setAvailableItemsHeader(data.Fields.length ? (data.Fields.filter(a => a.Name == "Description")[0].Description + 's')  : '');
            setGroups(tempGroups);
        }

    }, [data]);

    useEffect(() => {
        
        if (groups && groups.length > 0) {
            if (tempTypeText) {
                setTempTypeText(null);
                setSelectedGroup(groups[groups.length - 1])
            }
            else
                setSelectedGroup(groups[0]);
        }
        else {
            setSelectedGroup(null);
        }

    }, [groups]);

    useEffect(() => {
        
        setCurrentData(data);
    }, [selectedGroup]);

    useEffect(() => {
        if (currentData && currentData.LookUpItems) {
            const tempdata = currentData.LookUpItems.filter(a =>
                currentData.SelectedItems.findIndex(b => b.Type.toString() === selectedGroup?.Id
                    && b.Description === a.Id) < 0
                && (a.Description.toLowerCase().includes(searchText.toLowerCase()) ||
                    (a.Id.toLowerCase().includes(searchText.toLowerCase()))));
            setAvailableItems(tempdata);

        }
    }, [currentData, searchText])



    const onClickAddtoLeft = (event: any, item: DropdownModel) => {
        let tempdata = { ...currentData }
        let subTypes=tempdata.TypeLookups.filter(a=>a.FieldName=="SubType");
        tempdata.SelectedItems.push({Version:selectedVersion??"",BackwardCompatibilityVersion:null, Description: item.Id, IsSelected: false, IsChanged:true,IsDeleted:false,
            Id: 0, Type: parseInt(selectedGroup?.Id ?? '0'),SubType:subTypes.length?parseInt(subTypes[0].LookUpValues[0].Id):null });
        setCurrentData(tempdata);
        setIsEdited(true);
    }

    const onClickRemovefromLeft = (event: any, item: SelectableItem) => {
        let tempdata = { ...currentData }
        if(!item.Id)
            tempdata.SelectedItems.splice(tempdata.SelectedItems.findIndex(a => a.Description === item.Description && item.Type == a.Type), 1);
        else
            tempdata.SelectedItems.filter(a => a.Description === item.Description && item.Type == a.Type)[0].IsDeleted=true;
        setCurrentData(tempdata);
        setIsEdited(true);
    }

    const onChangeCapture = (event: any, item: SelectableItem) => {
        let tempdata = { ...currentData }
        let selectedIndex = tempdata.SelectedItems.findIndex(a => a.Description === item.Description && item.Type == a.Type);
        tempdata.SelectedItems[selectedIndex].IsSelected = !item.IsSelected;
        tempdata.SelectedItems[selectedIndex].IsChanged = true;;
        setCurrentData(tempdata);
        setIsEdited(true);
    }

    const addOption = (event: any) => {
        console.log("addOption called");
        debugger;
        if (!tempTypeText) return;
        let tempGroups = [...groups];
        setTempIdCounter(tempIdCounter+1);
        tempGroups.push({ Id: tempIdCounter.toString(), Description: tempTypeText });
        setGroups(tempGroups);
        setIsEdited(true);
    }
    
  
    const handleSaveClick = () => {
        let modifiedData = { ...currentData }
        modifiedData.Version = selectedVersion ?? "";
        modifiedData.TypeLookups[0].LookUpValues=groups;
        const updateInput = { NlcId: selectedNlcs.length > 0 ? selectedNlcs[0].Id : 0, TocId: 1, InputData: modifiedData};
        magneticService.updateAcceptanceData(updateInput).then((response) => {
            if (response&& response.data) {
                dispatch(showsuccessmessage("The data is saved successfully."))
                setIsEdited(false);
                callback();
                
            }
        });
    }
    const handleSetCurrent = () => {
        setDialogTitle('Set Version');
        setDialogMessage('Are you sure to update the current version as ' + selectedVersion + '?');

        setDialogOpen(true);
    }

    const setCurrentVersion = useCallback((confirmed: boolean, remarks: string) => {
        setDialogOpen(false);
        if (confirmed) {
            magneticService.setCurrentVersion(selectedVersion ?? "", selectedTable?.Id ?? 0, remarks,selectedNlcs.length? selectedNlcs[0].Id:null).then((response) => {
                if (response.data.IsSuccess) {
                    dispatch(showsuccessmessage(response.data.Message))
                    callback();
                }
                else {
                    dispatch(showerrormessage(response.data.Message))
                }

            });
        }
    }, [selectedTable, selectedVersion]);

    const onSubtypeChange=(child: ReactNode,item:SelectableItem)=>{
        let subType=(child?.valueOf() as ReactElement)['props']['value'];
        let tempData = { ...currentData }
        tempData.SelectedItems.filter(a=>a.Id==item.Id&&a.Type==item.Type&& a.Description==item.Description)[0].SubType=subType;
        tempData.SelectedItems.filter(a=>a.Id==item.Id&& a.Type==item.Type&& a.Description==item.Description)[0].IsChanged=true;
        setCurrentData(tempData);  
        setIsEdited(true);
    }

   
   
    return (
        <Box>

            {(currentData.SelectedItems||currentData.LookUpItems)&&currentData.LookUpItems.length ? <Box>
                <Grid container spacing={2} sx={{  p: 1 }}>
                    <Grid xs={6} >
                        <Box >
                            <Typography variant="subtitle2" sx={{ mb: 1 }} >{selectedAcceptedHeader}</Typography>
                            <Grid container spacing={showAdd ? 1 : 0}>
                                <Grid xs={showAdd ? 8 : 12}>
                                    <Autocomplete
                                        disablePortal
                                        disableClearable
                                        options={groups}
                                        size="small"
                                        sx={{ width: '100%', mb: 1 }}
                                        value={selectedGroup??undefined}
                                        getOptionLabel={(option) => (typeof option === 'string') ? option : option.Description}
                                        renderInput={(params) => <TextField {...params} label={groupHeader+'(Type to add new List item)'} />}
                                        onChange={(event: any, newValue: DropdownModel | null | string) => {
                                           
                                            if (!(typeof newValue === 'string'))
                                                setSelectedGroup(newValue);
        

                                        }}


                                        onInputChange={(event: React.SyntheticEvent, value: string, reason: string) => {
                                            
                                            if (value && groups.findIndex(a => a.Description.toLowerCase() === value.toLowerCase()) < 0) {
                                                setShowAdd(true);
                                                setTempTypeText(value);
                                                //to set selected group 
                                                const newGroup: DropdownModel = { Id: tempIdCounter.toString(), Description: value };
                                                setTempIdCounter(tempIdCounter + 1);
                                                setSelectedGroup(newGroup);
                                        
                                            } else {
                                                setShowAdd(false);
                                        
                                                //existing group
                                                const existingGroup = groups.find(a => a.Description.toLowerCase() === value.toLowerCase());
                                                if (existingGroup) {
                                                    setSelectedGroup(existingGroup);
                                                } else {
                                                    setSelectedGroup(null);  
                                                }
                                            }
                                        }}
                                        
                                        renderOption={(props, option) => (
                                            <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                                                {(typeof option === 'string') ? option : option.Description}
                                            </Box>
                                        )}
                                    />
                                </Grid>
                                <Grid xs={showAdd ? 4 : 0}>{showAdd ?
                                    <Button variant="outlined" onClick={addOption}>Add</Button> : null}
                                </Grid>


                            </Grid>
                            <List dense role='list' sx={{ maxHeight: 780, overflowY: 'auto' }}>

                                {(currentData.SelectedItems||currentData.LookUpItems) && selectedGroup ?
                                    currentData.SelectedItems.filter(a =>!a.IsDeleted&& a.Type.toString() === selectedGroup.Id).map((item: SelectableItem) => {
                                        return (
                                            <ListItem
                                                key={item.Description}
                                                role="listitem"
                                                disablePadding
                                                secondaryAction={
                                                   currentData.IsEditable? <IconButton edge="end" aria-label="remove item" onClick={(event) => onClickRemovefromLeft(event, item)}>
                                                        <Delete sx={{ color: "primary.main" }} />
                                                    </IconButton>:null
                                                }
                                            >
                                                <ListItemIcon>
                                                    <Checkbox
                                                        checked={item.IsSelected}
                                                        tabIndex={-1}
                                                        disableRipple
                                                        disabled={!currentData.IsEditable}
                                                        sx={{cursor:currentData.IsEditable?"pointer":"not-allowed"}}
                                                        onChange={(event) => onChangeCapture(event, item)}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText primary={item.Description + ' - ' + currentData.LookUpItems.filter(a => a.Id == item.Description)[0].Description} />
                                                {item.SubType!=null?
                                                <Select sx={{mr:5}} disabled={!currentData.IsEditable} defaultValue={item.SubType.toString()} size="small" onChange={(event,child)=>onSubtypeChange(child,item)}
                                                
                                                label={currentData.Fields.filter(a=>a.Name=="SubType")[0].Description}>
                                                    {currentData.TypeLookups.filter(a=>a.FieldName=="SubType")[0].LookUpValues.map((sitem:DropdownModel)=>{
                                                        return(
                                                            <MenuItem key={sitem.Id} value={sitem.Id}>{sitem.Description}</MenuItem>
                                                        )
                                                    })}
                                                </Select>:null

                                                }
                                            </ListItem>
                                        )
                                    })
                                    : null}
                            </List>
                        </Box>
                    </Grid>
                    <Grid xs={6}>
                        <Box  >
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>{availableItemsHeader}</Typography>
                            <TextField placeholder="Search" size="small" sx={{ width: '100%', mb: 1 }}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    setSearchText(event.target.value);
                                }} />

                            <FixedSizeList height={400} width={width} itemSize={40} itemCount={availableItems.length} overscanCount={5}>

                                {MeomisedListItem}
                            </FixedSizeList>
                        </Box>
                    </Grid>
                </Grid>
            </Box> : <Typography sx={{ m: 2 }} variant="h6">No data found for the current selection.</Typography>}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', m: 1 }}>
            {!currentData.ReadOnlyUser&&currentData.Version != selectedVersion ? <Button variant="outlined" onClick={handleSetCurrent}>Set Current Version</Button> : <div></div>}
                {currentData.IsEditable? <Button variant="contained" onClick={handleSaveClick}>Save</Button>:null}
                
            </Box>
            <ConfirmDialog needComments={true} isopen={dialogOpen} title={dialogTitle} message={dialogMessage} callback={setCurrentVersion} />
        </Box>

    )
}

export default function EditableAcceptanceDataList({ heading, data, parent,versions,callback }: 
    { heading: string | undefined, data: AcceptanceDataOutput, parent: string,versions:DropdownModel[],callback:any }) {

    return (
        <Card>
            <CardHeader sx={{ pb: 0 }} title={<DataTableHeader heading={heading} parent={parent} versions={versions} />} />
            <CardContent sx={{  pt: 0 }}>
                {heading == undefined ? '' : <EditableAcceptanceList data={data} parent={parent} callback={callback} />}
            </CardContent>
        </Card>
    );
}